<template>
    <CarouselReview :slides="data.reviews" />
</template>

<script setup lang="ts">
import type { ComponentReviewCarouselFragment } from '@/graphql/api'

import CarouselReview from '@/components/layout/carousels/review/CarouselReview.vue'

defineProps<{
    data: ComponentReviewCarouselFragment
}>()
</script>
